import React from 'react';
import { useTranslation } from 'react-i18next';
import TitleCard from 'components/TitleCard';
import useUniqueId from 'hooks/useUniqueId';
import UserEmailsContent from './UserEmailsContent';
import { jsx as _jsx } from "react/jsx-runtime";
function UserEmailsCard() {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var titleId = useUniqueId();
  return /*#__PURE__*/_jsx(TitleCard, {
    titleId: titleId,
    title: t('email_settings_card_title'),
    hideDivider: true,
    children: /*#__PURE__*/_jsx(UserEmailsContent, {})
  });
}
export default UserEmailsCard;